/* eslint-disable import/no-unused-modules */
import { useEffect, useState } from "react";
import { useConstantRefCallback } from "@jasperlabs/hooks";

const useScrollPosition = (callback) => {
	const callbackRef = useConstantRefCallback(callback);

	useEffect(() => {
		let lastKnownScrollPosition = 0;
		let ticking = false;
		const handleScroll = () => {
			lastKnownScrollPosition = window.scrollY;

			if (!ticking) {
				window.requestAnimationFrame(() => {
					callbackRef(lastKnownScrollPosition);
					ticking = false;
				});

				ticking = true;
			}
		};
		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [callbackRef]);
};

export const useDoesScrollPositionSatisfy = (match, initialState = false) => {
	const [doesSatisfy, setDoesSatisfy] = useState(initialState);

	useScrollPosition((position) => {
		setDoesSatisfy(match(position));
	});

	return doesSatisfy;
};

export default useScrollPosition;
